import styled from "styled-components";


export const LogoContainer = styled.div<{showControls: boolean}>`
    position: fixed; 
    top: -25px; 
    right: ${props => props.showControls ? '250px' : '100px'}; 
    transition: right 0.3s ease;
`